/**
 * Scarica un allegato di una mail. Il contenuto vive su Document Library lato
 * backend: si chiede il blob e lo si consegna al browser.
 *
 * Esiste come hook perche' i posti da cui si scarica sono tre — la smart inbox,
 * l'accordion della mail nella timeline e la card "Allegati" della scheda
 * preventivo (TS-108) — e tre copie della stessa `try/catch` avrebbero preso
 * strade diverse al primo errore da gestire.
 */

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { triggerBrowserDownload } from '@crm/shared';
import { useToast } from '../../components/useToast';
import { messageApi } from './messageApi';
import type { MessageAttachment } from './messageTypes';

export function useAttachmentDownload() {
  const toast = useToast();
  const { t } = useTranslation();

  return useCallback(
    async (attachment: MessageAttachment) => {
      try {
        const blob = await messageApi.downloadAttachment(
          attachment.messageId, attachment.messageAttachmentId);
        triggerBrowserDownload(blob, attachment.fileName);
      } catch {
        toast({ severity: 'error', message: t('message.attachmentDownloadError') });
      }
    },
    [toast, t],
  );
}
